import { Limit } from '@/domain/newRequest';
import { LimitsUsage } from '@/hooks/useUsedLimits/useUsedLimits';

/** The only field of the v3 response beyond {@link Limit} this conversion needs */
export type LimitWithDaysAvailable = Limit & { daysAvailableToUse?: number };

export const convertLimitsToLimitsUsageApiV2 = (allReadyLimits: LimitWithDaysAvailable[]): LimitsUsage[] => {
    return allReadyLimits
        .filter(absence => Boolean(absence))
        .map(absence => {
            if (absence.limit.noLimits && !absence.restriction) {
                return { ...absence, daysLeft: 0 };
            }

            // The API already accounts for the shared pool, carried over days and manual corrections
            if (absence.daysAvailableToUse != null) {
                return { ...absence, daysLeft: Math.max(0, absence.daysAvailableToUse) };
            }

            const limitsDaysLeft = absence.limit.limit - absence.daysUsed;

            if (absence.restriction) {
                const restrictionDaysLeft = absence.restriction.restriction - absence.daysUsed;
                if (absence.limit.noLimits || restrictionDaysLeft <= limitsDaysLeft) {
                    return { ...absence, daysLeft: Math.max(0, restrictionDaysLeft) };
                }
            }

            return { ...absence, daysLeft: Math.max(0, limitsDaysLeft) };
        });
};
